export {
  filterProductForRange,
  getValidProductsForRange,
  getProductDataMapFilteredForRange as getProductFilteredForRange
} from "./filter-for-range";
